import { Form } from "react-bootstrap";
import Gray_Btn from "../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import React, { useEffect, useState } from "react";
import Success_Toster from "../../../../../common/common_modal/success_toster/Success_Toster";
import { useSelector } from "react-redux";
import { FixIDS } from "../../../../../utils/fixIDS";

const Filter = ({ setAdd, setSearchName }) => {
  const [success, setSuccess] = useState(false);
  const [localName, setLocalName] = useState("");

  const permissions = useSelector((state) => state.auth.permissions);
  const havePermission = permissions?.includes(FixIDS.payment_method.Add);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <section className="Filter">
      <div className="row me-0 ms-0">
        <div className="col-lg-10">
          <div className="common_filter_div">
            <div className="row">
              <div className="col-xl-9 col-lg-12 col-md-9">
                <Form className="form_div">
                  <div className="row g-1">
                    <div className="col-xl-4 col-lg-5 col-md-5 col-sm-10 col-12">
                      <div className="filter_div">
                        <Form.Label>Search By:</Form.Label>
                        <Form.Group>
                          <div className="row g-1">
                            <div className="col-md-7 col-sm-4 col-6">
                              <Form.Control
                                type="text"
                                placeholder="Payment Method"
                                value={localName}
                                onChange={(e) => setLocalName(e.target.value)}
                              />
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>

              <div className="col-xl-3 col-lg-12 col-md-3">
                <div className="btns_holder">
                  {/* {success ? (
                    <Success_Toster successText="Report Generated Successfully!" />
                  ) : ( */}
                  <>
                    <Gray_Btn
                      btnText="Cancel"
                      onClick={() => {
                        setLocalName("");
                        setSearchName("");
                      }}
                    />
                    <Black_Submit_Btn
                      btnText="Submit"
                      onClick={() => {
                        setSearchName(localName);
                        setSuccess(true);
                      }}
                    />
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>

        {havePermission && (
          <div className="col-lg-2 p-0">
            <div className="add_sample_div" onClick={() => setAdd(true)}>
              <div className="add_img_div">
                <img src="/assets/images/other/plus.png" className="add_img" />
              </div>
              <p className="inner_text">Add New Payment Method </p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Filter;
